<template>
  <div>
    <svg-icon :icon-class="iconClass" :class-name="className" />
    {{ content }}
  </div>
</template>

<script>
export default {
  name: 'CargoSvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    content: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>

</style>
